

































































































































import { Inject, Prop, Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { ProjectAPI } from '@/api/backend-client'
import { Project } from '@/api/model/project'
import { availableNewBuildTypes } from '@/api/types'
import axios from 'axios'

@Component
export default class ReferralFutureAddressForm extends Vue {
    @Inject() readonly saveReferral!: (referral: Referral) => Promise<void>
    @Inject() reloadReferral!: () => Promise<void>
    @Prop({ type: Boolean, required: false }) disabled!: boolean
    @Prop({ required: true }) readonly referral!: Referral
    saving: boolean = false
    loadingZipcodeData: boolean = false
    validZipcodeData: boolean = false
    projects: Project[] = []

    async mounted(): Promise<void> {
        await this.loadProjects()
    }

    async loadProjects(): Promise<void> {
        this.projects = await ProjectAPI.getAll({
            company: this.$currentCompany.id,
        })

        this.projects = this.projects.sort((a: Project, b: Project) => a.name.localeCompare(b.name))
    }

    async onSaveClick(): Promise<void> {
        this.saving = true
        await this.saveReferral(this.referral)
        this.saving = false
    }

    async checkZipcode() {
        if (!this.validFutureZipcode || !this.validFutureHouseNumber) {
            this.validZipcodeData = false
            this.referral.futureStreetname = null
            this.referral.futureCity = null
            this.referral.futureCountry = null
        }

        await this.fetchZipcodeData()
    }

    async fetchZipcodeData() {
        try {
            if (this.validFutureZipcode && this.validFutureHouseNumber) {
                this.loadingZipcodeData = true
                const response = await axios.get('https://api.postcodeapi.nu/v2/addresses', {
                    headers: {'x-api-key': '1ToA8FZ2eB9FZCvA53Ce79c83sMxVdtk2m7i58E2'},
                    params: {
                        postcode: this.referral.futureZipcode,
                        number: this.referral.futureStreetnumber,
                    },
                })

                if (response.data._embedded.addresses.length > 0) {
                    this.referral.futureZipcode = response.data._embedded.addresses[0].postcode
                    this.referral.futureStreetname = response.data._embedded.addresses[0].street
                    this.referral.futureCity = response.data._embedded.addresses[0].city.label
                    this.referral.futureCountry = 'Nederland'
                    this.validZipcodeData = true
                }
            }

        } finally {
            this.loadingZipcodeData = false
        }
    }

    get validFutureZipcode(): boolean {
        return this.referral.futureZipcode && this.referral.futureZipcode.length > 5
    }

    get validFutureHouseNumber(): boolean {
        return this.referral.futureStreetnumber && this.referral.futureStreetnumber.length > 0
    }

    get isInterCompany(): boolean {
        return this.referral.referredByBranch.company.id !== this.referral.assignedToBranch.company.id
    }

    get fromReferringCompany(): boolean {
        return this.referral.referredByBranch.company.id === this.$currentCompany.id
    }

    get fromAssigneeCompany(): boolean {
        return this.referral.assignedToBranch.company.id === this.$currentCompany.id
    }

    get availableNewBuildTypes() {
        return availableNewBuildTypes().map(type => {
            return {
                label: this.$t(`new_build_type.${type}`),
                value: type,
            }
        })
    }
}
